import React from "react";
import { Button } from "react-bootstrap";
import html2pdf from "html2pdf.js";
import { useGetKYCDataMutation } from "../../app/features/apiSlice";
import { toastError } from "../../helpers";
import { useTranslation } from "react-i18next";

export default function ClientInfo({ language, userId, title }) {
  const [getKycdata] = useGetKYCDataMutation();
  const { t } = useTranslation();

  const handleDownloadPdf = async () => {
    try {
      const response = await getKycdata({ language, userId });
      if (response?.error) {
        toastError(response?.error);
      } else {
        if (response?.data) {
          pdfRender(response?.data);
        }
      }
    } catch (err) {
      toastError(err, "Server Not Responding");
    }
  };

  const pdfRender = async (data) => {
    const element = document.createElement("div");
    let htmlContent = `
      <div style="width: 100%; max-width: 1200px; margin: 0 auto; font-family: Noto Sans Gothic;" id="faturra">
        <table style="width: 100%; color: #000; font-size: 14px; border: 0; border-collapse: collapse;">
          <tbody>
            <tr>
              <td style="font-size: 52px; color:rgb(7, 7, 7); font-weight: 900; text-transform: uppercase; text-align: center; vertical-align: top;">
                KYC
              </td>
            </tr>
          </tbody>
        </table>
        <table style="width: 100%; color: #000; font-size: 14px; border: 0; border-collapse: collapse; margin-top: 30px;">
          <tbody>
            <tr>
              <td style="border: 1px solid #000; padding: 0;">
                <div style="padding: 5px; font-size: 14px; font-weight: bold; color: #fff; text-align: left; background:rgb(14, 13, 13);">
                  ${data?.userData?.first_name} ${data?.userData?.last_name}
                </div>
              </td>
              <td style="border: 1px solid #000; padding: 0;">
                <div style="padding: 5px; font-size: 14px; font-weight: bold; color: #fff; text-align: right; background:rgb(5, 5, 5);">
                 Status : ${data?.userData?.kyc_status}
                 
                </div>
              </td>
            </tr>
          </tbody>
        </table>
    `;

    data?.dossierData?.forEach((section) => {
      htmlContent += `
        <table style="width: 100%; color: #000; font-size: 14px; border: 1px solid gray; border-collapse: collapse; margin-top: 20px;">
          <tbody>
            <tr>
              <td colspan="2" style="font-size: 16px; font-weight: bold; text-align: center; background: #f0f0f0;">
                ${section.name}
              </td>
            </tr>
      `;
      section.questions.forEach((question) => {
        let answer = "";
        if (question.answer) {
          if (typeof question.answer === "string") {
            if (
              question.answer.trim().startsWith("{") &&
              question.answer.trim().endsWith("}")
            ) {
              const parsedAnswer = JSON.parse(question.answer);
              if (parsedAnswer.country) {
                const country = parsedAnswer.country?.label || "";
                const state = parsedAnswer.state?.label || "";
                const city = parsedAnswer.city?.label || "";
                answer = `${city}, ${state}, ${country}`
                  .trim()
                  .replace(/,\s*$/, "");
              } else {
                answer = parsedAnswer.label || "";
              }
            } else if (
              question.answer.trim().startsWith("[") &&
              question.answer.trim().endsWith("]")
            ) {
              const parsedAnswer = JSON.parse(question.answer);
              answer = parsedAnswer.map((item) => item.label).join(", ");
            } else {
              answer = question?.answer || "";
            }
          } else if (typeof question.answer === "object") {
            question.answer.forEach((url) => {
              answer += `<a href="${url}" target="_blank">View</a><br>`;
            });
          } else  if (question.otherAnswer) {
            answer = `${question.answer} (${question.otherAnswer})`;
          } 
            else {
              answer = question?.answer || "";
            }
        } else {
          answer = "N/A";
        }
        htmlContent += `
      <tr>
        <td style="border-bottom: 1px solid gray; padding: 5px; background: white; font-size: 14px; font-weight: bold; color: #000000; text-align: left;">
          ${question.label}
        </td>
        <td style="border-bottom: 1px solid gray; padding: 5px; background: white; font-size: 14px; color: #000000; text-align: right;">
          ${answer}
        </td>
      </tr>
    `;
      });

      htmlContent += "</tbody></table>";

    });
 htmlContent += ` 
      <table style="width: 100%; color: #000; font-size: 14px; border: 1px solid gray; border-collapse: collapse; margin-top: 20px;">
        <tbody>
          <tr>
            <td style="font-size: 16px; font-weight: bold; text-align: center; background:#000000; color: #fff;">
              Worldcheck
            </td>
          </tr>
        <tbody>
      </table>
      <table style="width: 100%; color: #000; font-size: 14px; border: 1px solid gray; border-collapse: collapse; margin-top: 20px;">
        <tbody>  
          <tr>
            <td style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; font-weight: bold; color: #000000;">
            ${t("noOfCases")}
            </td>
            <td style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; color: #000000; text-align: right;">
              ${data?.caseItems?.total_count || "N/A"}
            </td>
          </tr>
        </tbody>
      </table>`
    if (data.caseItems.total_count > 0) {
      htmlContent += `
          <table style="width: 100%; color: #000; font-size: 14px; border: 1px solid gray; border-collapse: collapse;">
            <thead style="font-weight: bold;">
              <tr>
                <th style="border: 1px solid #ddd; padding: 8px; width: 5%;">#</th>
                <th style="border: 1px solid #ddd; padding: 8px; width: 20%;">${t("name")}</th>
                <th style="border: 1px solid #ddd; padding: 8px; width: 15%;">${t("state_")}</th>
                <th style="border: 1px solid #ddd; padding: 8px; width: 15%;">${t("type")}</th>
                <th style="border: 1px solid #ddd; padding: 8px; word-wrap: break-word; width: 10%;">${t("country_risk")}</th>
                <th style="border: 1px solid #ddd; padding: 8px; word-wrap: break-word; width: 20%;">${t("risk_type")}</th>
                <th style="border: 1px solid #ddd; padding: 8px; word-wrap: break-word; width: 15%; word-wrap: break-word;">${t("updatedAt")}</th>
              </tr>
            </thead>
            <tbody>`
      data.caseItems.cases.forEach((item, i) => {
        let adjustedRiskLevel = item?.risk_level;
        if (item?.risk_types.includes('PEP')) {
          adjustedRiskLevel = 'MEDIUM';
        }
        if (item?.risk_types.includes('Sanction')) {
          adjustedRiskLevel = 'HIGH';
        }
        htmlContent += `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 8px;">${i + 1}</td>
                    <td style="border: 1px solid #ddd; padding: 8px;">${item.name}</td>
                    <td style="border: 1px solid #ddd; padding: 8px;">${item.type}</td>
                    <td style="border: 1px solid #ddd; padding: 8px;">${item.state}</td>
                    <td style="border: 1px solid #ddd; padding: 8px;">${adjustedRiskLevel}</td>
                    <td style="border: 1px solid #ddd; padding: 8px;">${item.risk_types}</td>
                    <td style="border: 1px solid #ddd; padding: 8px;">${item.updated_at}</td>
                  </tr>
                `;
      });
      htmlContent += `
            </tbody>
          </table>`;
    }
    htmlContent += `
        <table style="width: 100%; color: #000; font-size: 14px; border: 1px solid gray; border-collapse: collapse; margin-top: 20px;">
          <tbody>
            <tr>
              <td style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; font-weight: bold; color: #000000;">
                ${t("overAllRiskscore")}
              </td>
              <td colspan="2" style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; color: #000000; text-align: right;">
                ${data?.riskData?.overall_result?.score}
              </td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; font-weight: bold; color: #000000;">
                ${t("riskStatus")}
              </td>
              <td colspan="2" style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; color: #000000; text-align: right;">
                ${data?.riskData?.overall_result?.level}
              </td>
            </tr>  
            ${data?.riskData?.category_results?.map(category => `
            <tr>
              <td style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; color: #000000;">
                ${t("riskCategory")}: ${category.category}
              </td>
              <td style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; color: #000000;">
                ${t("level")}: ${category.level}
              </td>
              <td style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; color: #000000; text-align: right;">
                ${t("score")}: ${category.score}
              </td>
            </tr>
            ${category.attribute_results && category.attribute_results.length > 0 ? `
              <tr>
                <td colspan="3" style="border-bottom: 1px solid gray; padding: 5px; font-size: 14px; color: #000000;">
                  ${category.attribute_results.map(attribute => `
                    <span>
                      ${t("name")}: ${attribute.attribute_name} | 
                      ${t("value")}: ${attribute.evaluated_parameter}
                    </span>
                  `).join('')}
                </td>
              </tr> ` : ''}
            `).join('')}
          </tbody>
        </table>`;
    htmlContent += `</div>`;

    element.innerHTML = htmlContent;

    const options = {
      margin: 0.5,
      filename: `KYC ${title}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 4 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      enableLinks: true, // This ensures links are clickable in the PDF
    };

    html2pdf().from(element).set(options).save();
  };

  return (
    <Button onClick={handleDownloadPdf} size="sm" variant="gold" className="mb-1">
      <i className="fa fa-download" /> KYC
    </Button>
  );
}
